import React from 'react';

const CTF: React.FC = () => {
  const titles = {
    AcousticIntelligence: '🎙️ Acoustic Intelligence',
    RadiologyIntelligence: '🩻 Radiology Intelligence',
    PathologyIntelligence: '🔬 Pathology Intelligence',
    MultimodalFusion: '🧬 Multimodal Fusion',
    CTF: '🧠 Concept Tuning & Fusion (CTF)'
  };
  
  const descriptions = {
    AcousticIntelligence: 'Spectral/temporal/harmonic features, cough segmentation, auscultation analysis.',
    RadiologyIntelligence: 'CXR/CT analysis, spatial attribution heatmaps, radiogenomics.',
    PathologyIntelligence: 'Whole-slide imaging, graph-based learning, micro-environmental data.',
    MultimodalFusion: 'Fusion of all modalities with attention mechanisms and residual embeddings.',
    CTF: 'UMLS/SNOMED ontology alignment, knowledge graphs, concept-guided semantic fusion.'
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-20">
      <h1 className="font-serif text-4xl text-ink mb-4">{titles['CTF'] || 'CTF'}</h1>
      <p className="text-inkSoft text-lg max-w-3xl mb-8">
        {descriptions['CTF'] || 'Core capability of the CTF Platform.'}
      </p>
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-white border border-rule rounded-xl p-6">
          <h3 className="font-semibold text-ink mb-2">Key Capabilities</h3>
          <ul className="space-y-2 text-inkSoft text-sm">
            <li>✓ Real-time analysis</li>
            <li>✓ High accuracy</li>
            <li>✓ Explainable AI</li>
            <li>✓ Scalable deployment</li>
          </ul>
        </div>
        <div className="bg-white border border-rule rounded-xl p-6">
          <h3 className="font-semibold text-ink mb-2">Clinical Applications</h3>
          <ul className="space-y-2 text-inkSoft text-sm">
            <li>✓ Early detection</li>
            <li>✓ Risk stratification</li>
            <li>✓ Treatment monitoring</li>
            <li>✓ Research support</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CTF;
